
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as fire_pageNS3lmh_45zrTlFSp8SrSNA4XdTOev8xfmj2siVx4_45NQHsMeta } from "/app/pages/pump/fire_page.vue?macro=true";
import { default as total_pageF1CtBh9xopOziuRAPjGoWwBkrgoukI0wxQSkYJ_45WPpYMeta } from "/app/pages/pump/total_page.vue?macro=true";
import { default as water_pageIfY89rFMZTQPmkQjo_LizpjkscRLB1unjMG_3h_45MpAgMeta } from "/app/pages/pump/water_page.vue?macro=true";
import { default as drainage_pagejJ6U4wr6d6cuS_tzVsdUZZPrJ18EZ2r_45z2pZVRGX6nwMeta } from "/app/pages/pump/drainage_page.vue?macro=true";
import { default as map_pageDrNFvM16MiUwb7hkbC_45Pcd7Gv5K39umosrNjazB3JmsMeta } from "/app/pages/monitoring/map_page.vue?macro=true";
import { default as logs_pagegPS2a7U5VegzQYVWWkVyLWPQ8FN9OiiGsMXMEOz0YkoMeta } from "/app/pages/management/log/logs_page.vue?macro=true";
import { default as code_pagen_lDaLrry1LQAUH_QVHdYFB1_45f4LZfar30xKcmWb29kMeta } from "/app/pages/management/code/code_page.vue?macro=true";
import { default as menu_page6V_45qKiaKZ6II3oVjfrz_0KyiN_dmQlI2LmsZcHxsouQMeta } from "/app/pages/management/menu/menu_page.vue?macro=true";
import { default as user_pageQbGospyEXB_ucYTOZQxNm2Ptg0VftLmNky2gtu3km1IMeta } from "/app/pages/management/user/user_page.vue?macro=true";
import { default as board_pagex0ERzQvueBitEbCWmHkfovSwQ0fj0azY_45YwMYPwoPnUMeta } from "/app/pages/management/board/board_page.vue?macro=true";
import { default as group_pageI_45dWZDhuozU_p0fry0Qrh3lXMspSsYQe5bwhuo3ZezEMeta } from "/app/pages/management/group/group_page.vue?macro=true";
import { default as terms_pageT0xm6q_45KeakLyOzahl3LjB3txVERyD5XO21tBceMY9wMeta } from "/app/pages/management/terms/terms_page.vue?macro=true";
import { default as user_detailFrk1_1_hCBxl_45t2w8VgENbF4qpLwlo7barYBF9KaL9MMeta } from "/app/pages/management/user/user_detail.vue?macro=true";
import { default as board_detailt1bjho9tiJ8fdOlwO_EtAWxtiAEZtq20aGYYjQAGkGMMeta } from "/app/pages/management/board/board_detail.vue?macro=true";
import { default as terms_detailn84u4tgeNbVQ598ccG90dqYeggxsoND2Fpxn57FFTm0Meta } from "/app/pages/management/terms/terms_detail.vue?macro=true";
import { default as user_registermYiElc_45lvfy9RsZ_nbkWPfoqH_GtxHSVusfHnsLzoQIMeta } from "/app/pages/management/user/user_register.vue?macro=true";
import { default as board_registerjPDtQev3jmzugCs2K5k8paQh6Ye8_45aCKhXZsiDGRGhYMeta } from "/app/pages/management/board/board_register.vue?macro=true";
import { default as code_detail_submveQ50scBfE6Kc5yr74rQVPS73jJEXbuL5Oy_7rkDy0Meta } from "/app/pages/management/code/code_detail_sub.vue?macro=true";
import { default as terms_registerhS2VqnX_45pI7U8DBTZ7PQ8gfLSv0h8CvWOElhLKgmeGgMeta } from "/app/pages/management/terms/terms_register.vue?macro=true";
import { default as code_detail_mainrFt_45r0tasMuYyxIf9ueIs32ErvwC_45_6HzcqOwqvDGhAMeta } from "/app/pages/management/code/code_detail_main.vue?macro=true";
import { default as code_register_subZ5FwT1nT3Q1ZjrE5aV_xKmN_bQ6XdZIrq0kkKqpm5JMMeta } from "/app/pages/management/code/code_register_sub.vue?macro=true";
import { default as facility_pageD1md34sWgZMmEWRIImulewMQqovQ_45BeL_M_45HrihmEggMeta } from "/app/pages/management/facility/facility_page.vue?macro=true";
import { default as terminal_pagexUoCf0fV3NahNbJODeTn3CF6rZtuzMXzGg_45JaVtphg0Meta } from "/app/pages/management/terminal/terminal_page.vue?macro=true";
import { default as code_register_mainEqUGgOh0o66_45bFK5a9BqetuwxRrOIzTtFAPmEgzkF3oMeta } from "/app/pages/management/code/code_register_main.vue?macro=true";
import { default as group_detail_userqHo0IrEqXaPPJxpF8iwZTlQCFs6ZCYsyGSfK8628ek0Meta } from "/app/pages/management/group/group_detail_user.vue?macro=true";
import { default as facility_detailc2FTq4U84ZejKD6RRyQWP4ffbPpYTQ6FPHW_h5rWInsMeta } from "/app/pages/management/facility/facility_detail.vue?macro=true";
import { default as terminal_detailJlF75h6lM6OoUZuc1vgdR9Y_K_45Yz3Jebo2SE1xAGbvcMeta } from "/app/pages/management/terminal/terminal_detail.vue?macro=true";
import { default as facility_register9ABYFsf2tC58mHY98Hw2Kxc8zODdcDyjE6ZFjER5yXYMeta } from "/app/pages/management/facility/facility_register.vue?macro=true";
import { default as terminal_registerZ4e9w1RPxE_1lNG6o33VBT02Y94LQxZL7yxBfv3FOD8Meta } from "/app/pages/management/terminal/terminal_register.vue?macro=true";
import { default as group_detail_facilityzSCErS_45kHIO6FypTwRn8A8LLRQOYMZ1zN77fuJ3y_c0Meta } from "/app/pages/management/group/group_detail_facility.vue?macro=true";
import { default as warranty_service_pageIRZjcX6kHoHGqKz1w8LiYXWM31btWkcDjJu90YxHD98Meta } from "/app/pages/management/warranty/warranty_service_page.vue?macro=true";
import { default as warranty_service_userGLbO0VhBFGBFxidt29kLWsV3H9oiSjv5WmxM01AmFscMeta } from "/app/pages/management/warranty/warranty_service_user.vue?macro=true";
import { default as warranty_service_manage6q3pusgJUvYgvX2xSMbZ4CQIF0TGBwTs3Mw9st1GJpgMeta } from "/app/pages/management/warranty/warranty_service_manage.vue?macro=true";
import { default as warranty_service_registerSfvwflotdZhf8d_SXDEpbyuwDW8DSiDV5X17nEbT9EkMeta } from "/app/pages/management/warranty/warranty_service_register.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "pump-fire_page",
    path: "/pump/fire_page",
    meta: fire_pageNS3lmh_45zrTlFSp8SrSNA4XdTOev8xfmj2siVx4_45NQHsMeta || {},
    component: () => import("/app/pages/pump/fire_page.vue")
  },
  {
    name: "pump-total_page",
    path: "/pump/total_page",
    meta: total_pageF1CtBh9xopOziuRAPjGoWwBkrgoukI0wxQSkYJ_45WPpYMeta || {},
    component: () => import("/app/pages/pump/total_page.vue")
  },
  {
    name: "pump-water_page",
    path: "/pump/water_page",
    meta: water_pageIfY89rFMZTQPmkQjo_LizpjkscRLB1unjMG_3h_45MpAgMeta || {},
    component: () => import("/app/pages/pump/water_page.vue")
  },
  {
    name: "pump-drainage_page",
    path: "/pump/drainage_page",
    meta: drainage_pagejJ6U4wr6d6cuS_tzVsdUZZPrJ18EZ2r_45z2pZVRGX6nwMeta || {},
    component: () => import("/app/pages/pump/drainage_page.vue")
  },
  {
    name: "monitoring-map_page",
    path: "/monitoring/map_page",
    meta: map_pageDrNFvM16MiUwb7hkbC_45Pcd7Gv5K39umosrNjazB3JmsMeta || {},
    component: () => import("/app/pages/monitoring/map_page.vue")
  },
  {
    name: "management-log-logs_page",
    path: "/management/log/logs_page",
    meta: logs_pagegPS2a7U5VegzQYVWWkVyLWPQ8FN9OiiGsMXMEOz0YkoMeta || {},
    component: () => import("/app/pages/management/log/logs_page.vue")
  },
  {
    name: "management-code-code_page",
    path: "/management/code/code_page",
    meta: code_pagen_lDaLrry1LQAUH_QVHdYFB1_45f4LZfar30xKcmWb29kMeta || {},
    component: () => import("/app/pages/management/code/code_page.vue")
  },
  {
    name: "management-menu-menu_page",
    path: "/management/menu/menu_page",
    meta: menu_page6V_45qKiaKZ6II3oVjfrz_0KyiN_dmQlI2LmsZcHxsouQMeta || {},
    component: () => import("/app/pages/management/menu/menu_page.vue")
  },
  {
    name: "management-user-user_page",
    path: "/management/user/user_page",
    meta: user_pageQbGospyEXB_ucYTOZQxNm2Ptg0VftLmNky2gtu3km1IMeta || {},
    component: () => import("/app/pages/management/user/user_page.vue")
  },
  {
    name: "management-board-board_page",
    path: "/management/board/board_page",
    meta: board_pagex0ERzQvueBitEbCWmHkfovSwQ0fj0azY_45YwMYPwoPnUMeta || {},
    component: () => import("/app/pages/management/board/board_page.vue")
  },
  {
    name: "management-group-group_page",
    path: "/management/group/group_page",
    meta: group_pageI_45dWZDhuozU_p0fry0Qrh3lXMspSsYQe5bwhuo3ZezEMeta || {},
    component: () => import("/app/pages/management/group/group_page.vue")
  },
  {
    name: "management-terms-terms_page",
    path: "/management/terms/terms_page",
    meta: terms_pageT0xm6q_45KeakLyOzahl3LjB3txVERyD5XO21tBceMY9wMeta || {},
    component: () => import("/app/pages/management/terms/terms_page.vue")
  },
  {
    name: "management-user-user_detail",
    path: "/management/user/user_detail",
    meta: user_detailFrk1_1_hCBxl_45t2w8VgENbF4qpLwlo7barYBF9KaL9MMeta || {},
    component: () => import("/app/pages/management/user/user_detail.vue")
  },
  {
    name: "management-board-board_detail",
    path: "/management/board/board_detail",
    meta: board_detailt1bjho9tiJ8fdOlwO_EtAWxtiAEZtq20aGYYjQAGkGMMeta || {},
    component: () => import("/app/pages/management/board/board_detail.vue")
  },
  {
    name: "management-terms-terms_detail",
    path: "/management/terms/terms_detail",
    meta: terms_detailn84u4tgeNbVQ598ccG90dqYeggxsoND2Fpxn57FFTm0Meta || {},
    component: () => import("/app/pages/management/terms/terms_detail.vue")
  },
  {
    name: "management-user-user_register",
    path: "/management/user/user_register",
    meta: user_registermYiElc_45lvfy9RsZ_nbkWPfoqH_GtxHSVusfHnsLzoQIMeta || {},
    component: () => import("/app/pages/management/user/user_register.vue")
  },
  {
    name: "management-board-board_register",
    path: "/management/board/board_register",
    meta: board_registerjPDtQev3jmzugCs2K5k8paQh6Ye8_45aCKhXZsiDGRGhYMeta || {},
    component: () => import("/app/pages/management/board/board_register.vue")
  },
  {
    name: "management-code-code_detail_sub",
    path: "/management/code/code_detail_sub",
    meta: code_detail_submveQ50scBfE6Kc5yr74rQVPS73jJEXbuL5Oy_7rkDy0Meta || {},
    component: () => import("/app/pages/management/code/code_detail_sub.vue")
  },
  {
    name: "management-terms-terms_register",
    path: "/management/terms/terms_register",
    meta: terms_registerhS2VqnX_45pI7U8DBTZ7PQ8gfLSv0h8CvWOElhLKgmeGgMeta || {},
    component: () => import("/app/pages/management/terms/terms_register.vue")
  },
  {
    name: "management-code-code_detail_main",
    path: "/management/code/code_detail_main",
    meta: code_detail_mainrFt_45r0tasMuYyxIf9ueIs32ErvwC_45_6HzcqOwqvDGhAMeta || {},
    component: () => import("/app/pages/management/code/code_detail_main.vue")
  },
  {
    name: "management-code-code_register_sub",
    path: "/management/code/code_register_sub",
    meta: code_register_subZ5FwT1nT3Q1ZjrE5aV_xKmN_bQ6XdZIrq0kkKqpm5JMMeta || {},
    component: () => import("/app/pages/management/code/code_register_sub.vue")
  },
  {
    name: "management-facility-facility_page",
    path: "/management/facility/facility_page",
    meta: facility_pageD1md34sWgZMmEWRIImulewMQqovQ_45BeL_M_45HrihmEggMeta || {},
    component: () => import("/app/pages/management/facility/facility_page.vue")
  },
  {
    name: "management-terminal-terminal_page",
    path: "/management/terminal/terminal_page",
    meta: terminal_pagexUoCf0fV3NahNbJODeTn3CF6rZtuzMXzGg_45JaVtphg0Meta || {},
    component: () => import("/app/pages/management/terminal/terminal_page.vue")
  },
  {
    name: "management-code-code_register_main",
    path: "/management/code/code_register_main",
    meta: code_register_mainEqUGgOh0o66_45bFK5a9BqetuwxRrOIzTtFAPmEgzkF3oMeta || {},
    component: () => import("/app/pages/management/code/code_register_main.vue")
  },
  {
    name: "management-group-group_detail_user",
    path: "/management/group/group_detail_user",
    meta: group_detail_userqHo0IrEqXaPPJxpF8iwZTlQCFs6ZCYsyGSfK8628ek0Meta || {},
    component: () => import("/app/pages/management/group/group_detail_user.vue")
  },
  {
    name: "management-facility-facility_detail",
    path: "/management/facility/facility_detail",
    meta: facility_detailc2FTq4U84ZejKD6RRyQWP4ffbPpYTQ6FPHW_h5rWInsMeta || {},
    component: () => import("/app/pages/management/facility/facility_detail.vue")
  },
  {
    name: "management-terminal-terminal_detail",
    path: "/management/terminal/terminal_detail",
    meta: terminal_detailJlF75h6lM6OoUZuc1vgdR9Y_K_45Yz3Jebo2SE1xAGbvcMeta || {},
    component: () => import("/app/pages/management/terminal/terminal_detail.vue")
  },
  {
    name: "management-facility-facility_register",
    path: "/management/facility/facility_register",
    meta: facility_register9ABYFsf2tC58mHY98Hw2Kxc8zODdcDyjE6ZFjER5yXYMeta || {},
    component: () => import("/app/pages/management/facility/facility_register.vue")
  },
  {
    name: "management-terminal-terminal_register",
    path: "/management/terminal/terminal_register",
    meta: terminal_registerZ4e9w1RPxE_1lNG6o33VBT02Y94LQxZL7yxBfv3FOD8Meta || {},
    component: () => import("/app/pages/management/terminal/terminal_register.vue")
  },
  {
    name: "management-group-group_detail_facility",
    path: "/management/group/group_detail_facility",
    meta: group_detail_facilityzSCErS_45kHIO6FypTwRn8A8LLRQOYMZ1zN77fuJ3y_c0Meta || {},
    component: () => import("/app/pages/management/group/group_detail_facility.vue")
  },
  {
    name: "management-warranty-warranty_service_page",
    path: "/management/warranty/warranty_service_page",
    meta: warranty_service_pageIRZjcX6kHoHGqKz1w8LiYXWM31btWkcDjJu90YxHD98Meta || {},
    component: () => import("/app/pages/management/warranty/warranty_service_page.vue")
  },
  {
    name: "management-warranty-warranty_service_user",
    path: "/management/warranty/warranty_service_user",
    meta: warranty_service_userGLbO0VhBFGBFxidt29kLWsV3H9oiSjv5WmxM01AmFscMeta || {},
    component: () => import("/app/pages/management/warranty/warranty_service_user.vue")
  },
  {
    name: "management-warranty-warranty_service_manage",
    path: "/management/warranty/warranty_service_manage",
    meta: warranty_service_manage6q3pusgJUvYgvX2xSMbZ4CQIF0TGBwTs3Mw9st1GJpgMeta || {},
    component: () => import("/app/pages/management/warranty/warranty_service_manage.vue")
  },
  {
    name: "management-warranty-warranty_service_register",
    path: "/management/warranty/warranty_service_register",
    meta: warranty_service_registerSfvwflotdZhf8d_SXDEpbyuwDW8DSiDV5X17nEbT9EkMeta || {},
    component: () => import("/app/pages/management/warranty/warranty_service_register.vue")
  }
]